import { loginError, logoutSuccess } from "./reducer";
import {  Dispatch } from "redux";
import { getFirebaseBackend } from "helpers/firebase_helper";

export const logoutUser = () => async (dispatch: Dispatch) => {
    try {
        localStorage.removeItem("authUser");

        if (import.meta.env.REACT_APP_DEFAULTAUTH === "firebase") {
            const fireBaseBackend = getFirebaseBackend();
            await fireBaseBackend.logout();
            dispatch(logoutSuccess(true));
        } else {
            dispatch(logoutSuccess(true));
        }
    } catch (error) {
        dispatch(loginError(error));
    }
}

